import { Stack } from "@mui/material";
import { logEvent } from "@src/appV2/lib/analytics";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { Button } from "../../components/Button";
import { useVisitFiltersContext } from "../Filters/useVisitFiltersContext";
import { IN_HOME_USER_EVENTS } from "../lib/events";

interface InHomeOpenVisitsEmptyStateProps {
  unfilteredVisitsCount: number;
}

export function InHomeOpenVisitsEmptyState(props: InHomeOpenVisitsEmptyStateProps) {
  const { unfilteredVisitsCount } = props;
  const { appliedFiltersCount, clearFilters } = useVisitFiltersContext();
  const showResetFilters = appliedFiltersCount > 0 && unfilteredVisitsCount > 0;

  return (
    <Stack sx={{ flex: 1, justifyContent: "center" }} spacing={5}>
      <Title semibold variant="h4" component="h3" sx={{ textWrap: "balance", textAlign: "center" }}>
        {showResetFilters ? "No visits match your filters" : "There are no visits available"}
      </Title>
      {showResetFilters ? (
        <Button
          variant="contained"
          size="medium"
          sx={{ width: "fit-content", alignSelf: "center" }}
          onClick={() => {
            logEvent(IN_HOME_USER_EVENTS.FILTERS_CLEARED, { trigger: "Empty State" });
            clearFilters();
          }}
        >
          Reset filters to see {unfilteredVisitsCount} {pluralize("visit", unfilteredVisitsCount)}
        </Button>
      ) : (
        <Text
          semibold
          variant="body2"
          sx={{ paddingBottom: 8, textWrap: "balance", textAlign: "center" }}
        >
          We&apos;ll send you a notification when new visits are available
        </Text>
      )}
    </Stack>
  );
}
